import { Link } from "react-router-dom";
import { brand, stats } from "@/mocks/site";
import { getFeaturedCases } from "@/utils/cases";

export default function HeroSection() {
  const [lead] = getFeaturedCases();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden bg-secondary-950">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20composition%20of%20layered%20ink%20black%20geometric%20slabs%20and%20faint%20paper%20grain%20texture%20crossed%20by%20deep%20crimson%20and%20amber%20light%20streaks%2C%20dramatic%20vignette%20and%20deep%20shadows%2C%20moody%20investigative%20documentary%20atmosphere%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=hero-dark-dossier-2026&orientation=landscape"
        alt="暗色抽象背景，象征被遮蔽的行业信息与调查笔记"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/92 via-background-950/78 to-background-950/45"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-transparent to-background-950/40"></div>

      <div className="relative z-10 w-full max-w-[1240px] mx-auto px-4 md:px-10 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-400/50 bg-primary-500/15 text-primary-100 text-xs tracking-wide mb-6 animate-fade-up">
              <i className="ri-radar-line" aria-hidden="true"></i>
              {brand.since} 年起持续追踪 · {brand.slogan}
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold text-background-50 leading-[1.18] animate-fade-up">
              把潜规则与行业黑幕，
              <br />
              还原成你看得懂的流程
            </h1>
            <p className="mt-6 text-sm md:text-base text-background-200 leading-relaxed max-w-xl animate-fade-up">
              {brand.name}专注圈内规则、暗箱操作与灰色地带的调查整理。我们不制造传闻，只把一次交易、一份合同、一条流程里真正决定结果的那几个环节标出来，让你在下一次决定之前有话可问。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/cases"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-folder-open-line" aria-hidden="true"></i>
                进入调查档案库
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-team-line" aria-hidden="true"></i>
                了解我们的做法
              </Link>
            </div>

            <dl className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-5 md:gap-6">
              {stats.map((item) => (
                <div key={item.label} className="border-l border-background-50/20 pl-4">
                  <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                    {item.value}
                  </dt>
                  <dd className="mt-1 text-xs text-background-200">{item.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          {lead && (
            <div className="lg:col-span-5 hidden lg:block">
              <Link
                to={`/cases/${lead.id}`}
                className="block rounded-lg overflow-hidden border border-background-50/15 bg-background-50/5 backdrop-blur-sm hover:border-primary-400/60 transition-colors group"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-secondary-900">
                  <img
                    src={lead.cover}
                    alt={lead.coverAlt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    本周重点档案
                  </span>
                </div>
                <div className="p-5 md:p-6">
                  <p className="text-xs text-accent-400 mb-2">{lead.categoryLabel}</p>
                  <h2 className="font-heading text-lg font-bold text-background-50 leading-snug group-hover:text-accent-400 transition-colors">
                    {lead.title}
                  </h2>
                  <p className="mt-3 text-xs text-background-200 leading-relaxed line-clamp-2">
                    {lead.summary}
                  </p>
                  <p className="mt-4 flex items-center gap-1 text-xs text-background-100">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {lead.readTime}阅读 ｜ {lead.date}
                  </p>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}